import Marquee from "react-fast-marquee";
import { Leaf } from "lucide-react";
import { useLang } from "../../i18n";
import { MARQUEE_ITEMS } from "../../data/content";

export default function MarqueeBand() {
  const { lang } = useLang();
  const items = MARQUEE_ITEMS[lang] || MARQUEE_ITEMS.hi;
  return (
    <div data-testid="marquee-band" className="bg-ngo-mint border-y border-ngo-deep/10 py-5 overflow-hidden" aria-hidden="true">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="marquee-serif flex items-center gap-8 mx-8 text-ngo-forest/80 text-lg sm:text-xl font-medium">
            {item}
            <Leaf size={16} className="text-ngo-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
